// extracted by mini-css-extract-plugin
module.exports = {"call__icon":"c5_sd","call__phone":"c5_sf"};